module.exports = __webpack_public_path__ + "static/img/7662cb14bc17049bf30f105a49c82ec3.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/Recharge/images/wechatpay_phone.png
// module id = 2807
// module chunks = 1